import { BrowserStorageService } from 'services/BrowserStorageService';

const SessionStorageService = BrowserStorageService('session');

export { SessionStorageService };
